import { useId } from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { sourceInfoRows, type FreshnessMeta, type SourceKind } from "@/lib/analytics/freshness";

type SourceInfoPopoverProps = {
  /** The tile's name, so the trigger's accessible name says whose source it opens. */
  label: string;
  kind: SourceKind;
  meta: FreshnessMeta | null;
};

/**
 * The tile's source popover (CMP-11.19, ANL-E04-S09 AC2): the source words, the as-of time and, for
 * kinds S and E, the data-through date. A click opens it; a click outside or Esc closes it.
 */
const SourceInfoPopover = ({ label, kind, meta }: SourceInfoPopoverProps) => {
  const id = useId();
  const rows = sourceInfoRows(kind, meta);
  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      rootClose
      overlay={
        <Popover id={id}>
          <Popover.Body>
            <ul className="list-unstyled mb-0">
              {rows.map((row) => (
                <li key={row}>{row}</li>
              ))}
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <Button variant="link" size="sm" className="pz-stat__source p-0" aria-label={`Source of ${label}`}>
        Source
      </Button>
    </OverlayTrigger>
  );
};

export default SourceInfoPopover;
